/**
 * created by xcc
 * 一般卡片
 *
 */
import React, {Component} from 'react';
import PropTypes from "prop-types";
import "./normalCard.css";

export default class NormalCard extends Component {

    static defaultProps = {
        width: "50%"
    };
    static propTypes = {
        contentList: PropTypes.array.isRequired, //数据源
        selectedDivKey: PropTypes.string.isRequired, //选中的div
        handleDivClick: PropTypes.func.isRequired, //点击函数
    };

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        const {
            width,
            contentList,
            selectedDivKey,
            handleDivClick,
        } = this.props;
        const itemWidth = `${100 / (contentList.length - 1)}%`;
        return (
            <div style={{width: width, textAlign: "center"}}>
                {contentList && contentList.map((item, index) => {
                    const divs = [];
                    if (index === 0) {
                        divs.push(
                            <div key={index} onClick={() => {
                                handleDivClick(item)
                            }} style={{
                                width: "100%",
                                padding: (selectedDivKey === item.key) ? "3px 0px" : "4px 0px",
                                cursor: "pointer",
                                background: item.style?.background,
                                ...((selectedDivKey === item.key) ? {...item.style?.checked} : "")
                            }}>
                                <div style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: 'space-between',
                                    padding: `0 16px`
                                }}>
                                    <div style={{display: "flex", alignItems: "center"}}>
                                        <img src={item.img}/>
                                        <div style={{
                                            paddingLeft: "16px",
                                            fontSize: 16,
                                            letterSpacing: 0.02,
                                            color: "#000000d9"
                                        }}>{item.title}</div>
                                    </div>
                                    <div style={{
                                        fontSize: "26px",
                                        fontWeight: "bold",
                                        letterSpacing: 0.02,
                                        marginBottom: "2px",
                                        color: item.color
                                    }}>{item.count}</div>
                                </div>
                            </div>
                        );
                    } else {
                        divs.push(
                            <div
                                key={index}
                                onClick={() => handleDivClick(item)}
                                style={{
                                    float: "left",
                                    width: item.style?.width || itemWidth,
                                    marginTop: 8,
                                    cursor: "pointer",
                                    borderRadius: item.style?.borderRadius,
                                    padding: `${item.style?.padding + "px"} 0`,
                                    marginLeft: (index > 1 && item.marginLeft) ? item.marginLeft : 0,
                                    ...((selectedDivKey === item.key) ? {...item.style?.checked} : {...item.style?.default})
                                }}>
                                <div style={{color: item.style?.color, position: "relative"}}>
                                    {item.img ?
                                        <img className={"normalCardImg"} style={{position: "absolute", left: 50, top: 17}} src={item.img}/> : null}
                                    <div className={"normalCardCount"} style={{
                                        fontSize: item.style?.countSize,
                                        marginBottom: "2px"
                                    }}>{item.count}</div>
                                    <div className={"normalCardText"} style={{
                                        fontSize: item.textSize,
                                    }}>{item.title}</div>
                                </div>
                            </div>
                        )
                    }
                    return divs;
                })}
            </div>
        )
    }
}